import { request } from '@/api/http';

/**
 * 获取我的会话列表
 */
export function getMyChatList(params) {
  return request({
    url: '/api/v5/chat/my',
    method: 'get',
    params: params
  });
}

/**
 * 增量同步消息
 * @param {Object} params - { chatId, afterSeq, limit }
 */
export function syncMessages(params) {
  return request({
    url: '/api/v5/chat/sync',
    method: 'get',
    params: params
  });
}

/**
 * 分页加载历史消息
 * @param {Object} params - { chatId, page, size }
 */
export function getHistoryMessages(params) {
  return request({
    url: '/api/v5/chat/message',
    method: 'get',
    params: params
  });
}

/**
 * 发送消息（统一入口）
 * @param {Object} data - ChatMessageInput
 */
export function postMessage(data) {
  return request({
    url: '/api/v5/message/user',
    method: 'post',
    data: data
  });
}

/**
 * 发送群消息
 * @param {Object} data - ChatMessageInput
 */
export function postGroupMessage(data) {
  return request({
    url: '/api/v5/message/group',
    method: 'post',
    data: data
  });
}

/**
 * 查询发送确认结果
 * @param {Object} params - { clientMsgId }
 */
export function getMessageAck(params) {
  return request({
    url: '/api/v5/message/ack',
    method: 'get',
    params: params
  });
}

/**
 * 上报已读位置
 * @param {Object} data - { chatId, readSeq }
 */
export function postRead(data) {
  return request({
    url: '/api/v5/chat/read',
    method: 'post',
    data: data
  });
}

/**
 * 创建会话
 * @param {Object} data - ChatMessageInput (初始消息)
 */
export function createChat(data) {
  return request({
    url: '/api/v5/chat/chat',
    method: 'post',
    data: data
  });
}

/**
 * 撤回消息
 * @param {Object} data - { messageId }
 */
export function recallMessage(data) {
  return request({
    url: '/api/v5/chat/recall',
    method: 'post',
    data: data
  });
}

/**
 * 搜索用户（新建对话用）
 * @param {Object} params - { keyword, page, size }
 */
export function searchUsers(params) {
  return request({
    url: '/api/v5/sys/user',
    method: 'get',
    params: params
  });
}

/**
 * 获取联系人浏览列表（组织化联系人）
 * @param {Object} params - { page, size, status, deptId, schoolId, keyword }
 */
export function getContactUsers(params) {
  return request({
    url: '/api/v5/sys/user',
    method: 'get',
    params: params
  });
}

/**
 * 获取部门列表（组织化联系人）
 */
export function getContactDepartments(params) {
  return request({
    url: '/api/v5/dept',
    method: 'get',
    params: params
  });
}

/**
 * 获取学校列表（组织化联系人）
 */
export function getContactSchools(params) {
  return request({
    url: '/api/v5/school',
    method: 'get',
    params: params
  });
}

/**
 * 获取院系列表（学生联系人）
 */
export function getContactFaculties(params) {
  return request({
    url: '/api/v5/faculty',
    method: 'get',
    params: params
  });
}

/**
 * 获取专业列表（学生联系人）
 */
export function getContactProfessions(params) {
  return request({
    url: '/api/v5/prof',
    method: 'get',
    params: params
  });
}

/**
 * 获取班级列表（学生联系人）
 */
export function getContactClazzes(params) {
  return request({
    url: '/api/v5/clazz',
    method: 'get',
    params: params
  });
}

/**
 * 获取学生联系人列表
 */
export function getContactStudents(params) {
  return request({
    url: '/api/v5/student',
    method: 'get',
    params: params
  });
}

/**
 * 获取群成员列表
 * @param {Object} params - { chatId }
 */
export function getGroupMembers(params) {
  return request({
    url: '/api/v5/chat/group/member',
    method: 'get',
    params: params
  });
}

/**
 * 获取群公告详情
 * @param {Object} params - { chatId }
 */
export function getGroupNotice(params) {
  return request({
    url: '/api/v5/chat/group/notice',
    method: 'get',
    params: params
  });
}

/**
 * 更新群资料
 * @param {Object} data - { chatId, name, avatar }
 */
export function updateGroupInfo(data) {
  return request({
    url: '/api/v5/chat/group/update',
    method: 'post',
    data: data
  });
}

/**
 * 更新群公告
 * @param {Object} data - { chatId, notice }
 */
export function updateGroupNotice(data) {
  return request({
    url: '/api/v5/chat/group/notice',
    method: 'post',
    data: data
  });
}

/**
 * 开关全员禁言
 * @param {Object} data - { chatId, isAllMuted }
 */
export function updateGroupAllMute(data) {
  return request({
    url: '/api/v5/chat/group/mute/all',
    method: 'post',
    data: data
  });
}
export function updateGroupAdmin(data) {
  return request({
    url: '/api/v5/chat/group/member/admin',
    method: 'post',
    data: data
  });
}
export function updateGroupMemberMute(data) {
  return request({
    url: '/api/v5/chat/group/member/mute',
    method: 'post',
    data: data
  });
}
export function removeGroupMember(data) {
  return request({
    url: '/api/v5/chat/group/member/remove',
    method: 'post',
    data: data
  });
}
export function transferGroupOwner(data) {
  return request({
    url: '/api/v5/chat/group/owner/transfer',
    method: 'post',
    data: data
  });
}
export function uploadImage(data) {
  return request({
    url: '/api/v5/sys/upload/image',
    method: 'post',
    data: data
  });
}